module.exports = __webpack_public_path__ + "static/headlinecaps-do-7357ebe406870a559e7d1b7ffeac25cc.png";